import styled from 'styled-components';
import { jsx } from 'react/jsx-runtime';

var ARROW_SIZE = 8;
var getArrowPaths = function getArrowPaths(size, position) {
  var horizontal = position === "top" || position === "bottom";
  var w = horizontal ? size * 2 : size;
  var h = horizontal ? size : size * 2;
  var points = {
    top: "".concat(w, " 0 ").concat(h, " ").concat(h, " 0 0 0 0"),
    bottom: "".concat(w, " ").concat(h, " ").concat(h, " 0 0 ").concat(h, " 0 ").concat(h),
    left: "0 ".concat(h, " ").concat(w, " ").concat(w, " 0 0 0 0"),
    right: "".concat(w, " ").concat(h, " 0 ").concat(w, " ").concat(w, " 0 ").concat(w, " 0")
  }[position];
  return {
    w: w,
    h: h,
    points: points
  };
};
var StyledSVG = styled.svg.withConfig({
  displayName: "TooltipArrow__StyledSVG",
  componentId: "sc-1wsk5db-0"
})(["&&{", ";", ";", ";}"], function (props) {
  return props.variant === "dark" && "\n        polyline {\n            fill: ".concat(props.theme.neutralColors.charcoal, ";\n        }\n    ");
}, function (props) {
  return props.variant === "light" && "\n        polyline {\n            stroke: ".concat(props.theme.neutralColors.silver, ";\n            fill: ").concat(props.theme.neutralColors.white, ";\n        }\n    ");
}, function (props) {
  return "\n        margin-".concat(props.position, ": -1px;\n    ");
});
var TooltipArrow = function TooltipArrow(props) {
  var _props$position = props.position,
    position = _props$position === void 0 ? "bottom" : _props$position,
    _props$size = props.size,
    size = _props$size === void 0 ? "sm" : _props$size,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? "dark" : _props$variant;
  var _getArrowPaths = getArrowPaths(ARROW_SIZE, position),
    h = _getArrowPaths.h,
    points = _getArrowPaths.points,
    w = _getArrowPaths.w;
  return /*#__PURE__*/jsx(StyledSVG, {
    height: h,
    position: position,
    size: size,
    variant: variant,
    width: w,
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/jsx("polyline", {
      points: points
    })
  });
};
TooltipArrow.displayName = "TooltipArrow";

export { TooltipArrow };
